import { Box } from "@mui/material";
import { DotLegalAlert, DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { Trans } from "react-i18next";
import { useTranslation } from "../localization/useTranslation.ts";
import { AiSpendingStatus, AiSpendingWarning, isAiSpendingExhausted } from "./AiAdministration.types.ts";
import { useUserContext } from "../auth/userContextProvider/UserContextProvider.tsx";
import { useUrlProvider } from "../useUrlProvider.ts";

interface AiSpendingWarningAlertProps {
    warning: AiSpendingWarning | undefined;
}

function AiSpendingWarningAlert({ warning }: AiSpendingWarningAlertProps) {
    const { translateString } = useTranslation();
    const { permissions } = useUserContext();
    const { getAiAdministrationUrl } = useUrlProvider();

    if (!warning || warning.status === AiSpendingStatus.None) {
        return null;
    }

    const isExhausted = isAiSpendingExhausted(warning);
    const canManageAiAdministration = permissions.canManageAiAdministration;
    const permissionSuffix = canManageAiAdministration ? "CanManageAiAdministration" : "CannotManageAiAdministration";
    const messageKey = isExhausted
        ? warning.hasMonthlySpendingLimit
            ? `aiCreditsExhaustedMessage${permissionSuffix}`
            : `aiWelcomeCreditExhaustedMessage${permissionSuffix}`
        : warning.hasMonthlySpendingLimit
          ? `aiCreditsAlmostExhaustedMessage${permissionSuffix}`
          : `aiWelcomeCreditAlmostExhaustedMessage${permissionSuffix}`;

    const warningText = canManageAiAdministration ? (
        <Trans
            i18nKey={messageKey}
            components={{
                here: (
                    <DotLegalLink underline bold linkColor="primary" to={getAiAdministrationUrl()}>
                        {undefined}
                    </DotLegalLink>
                ),
            }}
        />
    ) : (
        translateString(messageKey)
    );

    return (
        <Box sx={{ marginTop: 2 }}>
            <DotLegalAlert severity="warning" warningText={warningText} />
        </Box>
    );
}

export default AiSpendingWarningAlert;
